export const clothingSizes = [
  {
    us: '2',
    uk: '4',
    eu: '32',
    s: 'XXS',
  },
  {
    us: '4',
    uk: '6',
    eu: '34',
    s: 'XS',
  },
  {
    us: '6',
    uk: '8',
    eu: '36',
    s: 'S',
  },
  {
    us: '8',
    uk: '10',
    eu: '38',
    s: 'S',
  },
  {
    us: '10',
    uk: '12',
    eu: '40',
    s: 'M',
  },
  {
    us: '12',
    uk: '14',
    eu: '42',
    s: 'M',
  },
  {
    us: '14',
    uk: '16',
    eu: '44',
    s: 'L',
  },
  {
    us: '16',
    uk: '18',
    eu: '46',
    s: 'L',
  },
  {
    us: '18',
    uk: '20',
    eu: '48',
    s: 'XL',
  },
  {
    us: '20',
    uk: '22',
    eu: '50',
    s: 'XL',
  },
  {
    us: '22',
    uk: '24',
    eu: '52',
    s: 'XXL',
  },
  {
    us: '24',
    uk: '26',
    eu: '54',
    s: '3XL',
  },
  {
    us: '26',
    uk: '28',
    eu: '56',
    s: '4XL',
  },
];

export const shoesSizes = [
  {
    us: '5',
    uk: '2.5',
    eu: '35',
  },
  {
    us: '5.5',
    uk: '3',
    eu: '35.5',
  },
  {
    us: '6',
    uk: '3.5',
    eu: '36',
  },
  {
    us: '6.5',
    uk: '4',
    eu: '37',
  },
  {
    us: '7',
    uk: '4.5',
    eu: '37.5',
  },
  {
    us: '7.5',
    uk: '5',
    eu: '38',
  },
  {
    us: '8',
    uk: '5.5',
    eu: '38.5',
  },
  {
    us: '8.5',
    uk: '6',
    eu: '39',
  },
  {
    us: '9',
    uk: '6.5',
    eu: '40',
  },
  {
    us: '9.5',
    uk: '7',
    eu: '41',
  },
  {
    us: '10',
    uk: '7.5',
    eu: '42',
  },
  {
    us: '10.5',
    uk: '8',
    eu: '43',
  },
  {
    us: '12',
    uk: '9.5',
    eu: '44',
  },
  {
    us: '13',
    uk: '10.5',
    eu: '45',
  },
  {
    us: '14',
    uk: '11.5',
    eu: '46.5',
  },
  {
    us: '15.5',
    uk: '13',
    eu: '48.5',
  },
];

export const childrenShoesSizes = [
  { us: '4.5 or 5', uk: '4', eu: '20' },
  { us: '5 or 5.5', uk: '4.5', eu: '21' },
  { us: '5.5 or 6', uk: '5', eu: '21 or 22' },
  { us: '6', uk: '5.5', eu: '22' },
  { us: '6.5 or 7', uk: '6', eu: '23' },
  { us: '7.5', uk: '6.5', eu: '23 or 24' },
  { us: '7.5 or 8', uk: '7', eu: '24' },
  { us: '8 or 9', uk: '7.5', eu: '25' },
  { us: '8.5 or 9', uk: '8', eu: '25 or 26' },
  { us: '9.5', uk: '8.5', eu: '26' },
  { us: '9.5 or 10', uk: '9', eu: '27' },
  { us: '10.5 or 11', uk: '10', eu: '28' },
  { us: '11.5 or 12', uk: '10.5 or 11', eu: '29' },
  { us: '12.5', uk: '11.5', eu: '30' },
  { us: '13', uk: '12', eu: '31' },
  { us: '13 or 13.5', uk: '12.5', eu: '31' },
  { us: '1', uk: '13', eu: '32' },
  { us: '1.5', uk: '13.5', eu: '32.5' },
  { us: '1.5 or 2', uk: '1', eu: '33' },
  { us: '2.5 or 3', uk: '2', eu: '34' },
];

export const columns = [
  { title: 'US', dataIndex: 'us', key: 'us' },
  { title: 'UK', dataIndex: 'uk', key: 'uk' },
  { title: 'EU', dataIndex: 'eu', key: 'eu' },
];
